module.exports = __webpack_public_path__ + "img/vietcombank.ff768c45.png";